import { Entry, Asset } from 'contentful';

import { Lore } from 'types/Lore';
import { getEntries, getEntry } from './ContentfulClient';

type ContentfulLore = Lore & {
  image: Asset;
};

type LoreOrder = {
  name: string;
  order: Entry<ContentfulLore>[];
};

const transformAllLore = (lores: Entry<ContentfulLore>[]) => {
  const publishedLores = lores.filter((lore) => !!lore.fields);
  return publishedLores.map(transformLore);
};

const transformLore = (lore: Entry<ContentfulLore>) => {
  const { sys, fields } = lore;
  const { content, image, slug, title } = fields;

  return {
    id: sys.id,
    content,
    slug,
    title,
    imageUrl: image?.fields?.file?.url || '',
  };
};

const getDefaultLoreOrder = async () => {
  const loreOrders = await getEntries<LoreOrder>('loreOrder');

  if (loreOrders.total === 0) {
    throw new Error('No lore orderings found. Please check Contentful.');
  }

  const loreOrder = loreOrders.items.find((loreOrder) => loreOrder.fields.name === 'Default Order');

  if (!loreOrder) {
    throw new Error('No default lore ordering found. Please check Contentful.');
  }

  return loreOrder;
};

export const getAllLore = async () => {
  const loreOrder = await getDefaultLoreOrder();
  return transformAllLore(loreOrder.fields.order);
};

export const getLoreById = async (id: string) => {
  const entry = await getEntry<ContentfulLore>(id);
  return transformLore(entry);
};
